import { CSSProperties } from 'react';
const linkText: CSSProperties = {
    paddingTop: "20px",
    paddingBottom: "20px",
}

const styles = {linkText }
export default styles